<template>
  <div
    ref="dialog"
    v-click-outside="$_onClickOutside"
    class="whole-calendar-day-events-dialog"
    :class="[{show:show},{ts:ts}]"
    :style="{transform:_transformValue}"
  >
    <div class="day-events-dialog-title">{{title}}</div>
    <PerfectScrollbar class="day-events-dialog-events">
      <div
        @click="$_handleEventClick(event)"
        v-for="(event,eventIndex) in events"
        :key="eventIndex"
        class="event"
      >
        <img
          v-if="$_getEventTypeIcon(event.eventType)"
          class="icon"
          :src="$_getEventTypeIcon(event.eventType)"
          alt=""
        >
        <div class="name">{{event.name}}</div>
      </div>
    </PerfectScrollbar>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
export default {
  data: () => ({
    show: false,
    ts: true
  }),
  props: {
    title: String,
    events: Array,
    eventTypes: Array,
    position: Object
  },
  computed: {
    _transformValue() {
      if (!this.position) {
        return null;
      } else {
        if (!this.$refs.dialog) {
          return null;
        }
        const rect = this.$refs.dialog.getBoundingClientRect();
        return `translate(${this.position.x - rect.width / 2}px,${this.position
          .y - 20}px)`;
      }
    }
  },
  methods: {
    $_getEventTypeIcon(eventType) {
      if (!eventType) {
        return null;
      }
      const tarEventType = this.eventTypes.find(e => {
        return e.name == eventType;
      });
      if (!tarEventType) {
        return null;
      } else {
        return tarEventType.iconImage;
      }
    },
    $_handleEventClick($event) {
      this.$emit("event-click", $event);
    },
    $_onClickOutside() {
      this.close();
    },
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    }
  },
  components: {
    PerfectScrollbar
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
};
</script>
